export default __webpack_public_path__ + "static/media/apologize.d22c6830.png";